<template>
  <div>
    <div class="bg-white mt-20 mb-5">
      <Banner />
      <CampaignCard />
      <PartnerOrganization />
      <Partners />
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import Banner from "./components/Banner.vue";
import CampaignCard from "./components/CampaignCard.vue";
import PartnerOrganization from "./components/PartnerOrganization.vue"
import Partners from "./components/Partners.vue"
import Footer from "../Footer.vue";
import DownloadApp from "../corporate-events/components/DownloadApp.vue";

export default {
  components: {
    Banner,
    CampaignCard,
    PartnerOrganization,
    Partners,
    Footer,
    DownloadApp,
  },
};
</script>
